import PropTypes from 'prop-types';
import Icon from './base/Icon';
import * as LighthouseService from 'common/services/lighthouse.service';
import { numeralify } from 'common/utils/utils';
import { Flex } from './base/layout-components';
import Text from './base/Text';
import LineGauge from './LineGauge';
import { LBButton } from '@linearb/buzz';

const MetricsBox = ({
  label = '',
  units = '',
  value,
  articleId,
  note = null,
  dataCyPrefix = '',
  ...rest
}) => {
  return (
    <Flex height='100%' direction='column' basis='16rem'>
      <Flex
        height='100%'
        direction='row'
        items='center'
        align='center'
        justify='flex-start'
      >
        <Text color='gray' size='medium' weight='bold'>
          {label}
        </Text>

        <LBButton
          onClick={() => LighthouseService.navigateArticle(articleId)}
          size='icon'
          variant='outline'
        >
          <Icon name='helpicon' size='smaller' color='gray' />
        </LBButton>
      </Flex>
      <Flex direction='row' items='flex-end'>
        <Text
          size='huge'
          data-cy={`${dataCyPrefix}-${label.replace(/\s+/g, '-')}-value`}
        >
          {numeralify(value)}
        </Text>

        <Text size='medium' pl='0.5rem' pb='1rem'>
          {units}
        </Text>
      </Flex>

      <Text size='small' color='gray' pb='1rem' pt='1rem'>
        Industry standard benchmark
      </Text>
      <LineGauge value={value} {...rest} />
      {note ? (
        <Text size='small' color='gray' pb='1rem' pt='1rem'>
          {note}
        </Text>
      ) : null}
    </Flex>
  );
};

MetricsBox.propTypes = {
  label: PropTypes.string,
  units: PropTypes.string,
  ...LineGauge.PropTypes
};

export default MetricsBox;
